import React, { useCallback } from 'react'
import { Box, ImageLoader } from '@usap/uicomponents'
import PageTypeIdentifier from '@usap/carparts/src/shared/helpers/PageTypeIdentifier'
import {
  headerImageLoader,
  HeaderQandABox,
  linkHeaderStyle,
  PartText,
  PriceText,
} from './style/QuestionAnswerBox.css'

export default function QuestionAnswerHeader({
  productUrl,
  imageUrl,
  skuTitle,
  price,
  formatBrandInText,
  Link,
  isBot,
}) {
  const onClick = useCallback(() => PageTypeIdentifier.pdp(), [])

  return (
    <HeaderQandABox>
      <Link
        to={productUrl}
        onClick={onClick}
        style={linkHeaderStyle}
      >
        <ImageLoader
          source={imageUrl}
          src={imageUrl}
          isBot={isBot}
          width="100%"
          height="100%"
          style={headerImageLoader}
          cloudinaryParams="c_pad,f_auto,q_auto,dpr_auto,e_sharpen,w_100,h_100"
          overrideCloudinary={true}
        />
      </Link>
      <Box>
        <Link
          to={productUrl}
          onClick={onClick}
        >
          <PartText>
            { formatBrandInText(skuTitle) }
          </PartText>
        </Link>
        <Box>
          <PriceText>
            $
            { price }
          </PriceText>
        </Box>
      </Box>
    </HeaderQandABox>
  )
}
